module.exports = __webpack_public_path__ + "media/fonts/Roboto-BlackItalic-279b831d1cc21955a97a4b73e07d204e.ttf";